import type { BannerHeightCallback } from "./banner-height-callback.types";

export const bannerHeightCallbacks = { value: [] as BannerHeightCallback[] };
